import type { CSSProperties } from 'react';
import { useEffect, useState } from 'react';

import Sidebar from '../components/Sidebar';
import { api, type ReferralStats } from '../api/client';
import { T } from '../styles/tokens';

export default function Referral() {
  const [data, setData] = useState<ReferralStats | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.referral.get().then(setData).catch(console.error);
  }, []);

  const copy = () => {
    if (!data) return;
    navigator.clipboard?.writeText(data.link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={r.root}>
      <Sidebar active="referral" />
      <main style={r.main}>
        <div style={r.topBar}>
          <div>
            <div style={r.pageTag}>// бонусы</div>
            <div style={r.pageTitle}>Реферальная программа</div>
          </div>
        </div>

        <div style={r.bonusRow}>
          {[
            { who: 'Вы', val: '+7 дней' },
            { who: 'Друг', val: '+7 дней' },
          ].map((b) => (
            <div key={b.who} style={r.bonusCard}>
              <div style={r.bonusWho}>{b.who}</div>
              <div style={r.bonusVal}>{b.val}</div>
            </div>
          ))}
        </div>

        <div style={r.linkCard}>
          <div style={r.monoTag}>// ваша ссылка</div>
          <code style={r.linkCode}>{data?.link || '—'}</code>
          <button
            style={{ ...r.ctaBtn, background: copied ? T.success : T.accent, marginTop: 12 }}
            onClick={copy}
            disabled={!data}
          >
            {copied ? '✓ Скопировано' : 'Копировать ссылку'}
          </button>
        </div>

        <div style={r.statsRow}>
          {[
            [String(data?.invited_count ?? 0), 'Приглашено'],
            [String(data?.paid_count ?? 0), 'Оплатили'],
            [`${data?.bonus_days_received ?? 0} дн.`, 'Бонусов'],
          ].map(([v, l]) => (
            <div key={l} style={r.statItem}>
              <div style={r.statVal}>{v}</div>
              <div style={r.statLabel}>{l}</div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

const r: Record<string, CSSProperties> = {
  root: { display: 'flex', minHeight: '100vh', background: T.bg, fontFamily: 'DM Sans, sans-serif', color: T.text },
  main: { flex: 1, marginLeft: 220, padding: '36px 44px', boxSizing: 'border-box', maxWidth: 'calc(100vw - 220px)' },
  topBar: { marginBottom: 32 },
  pageTag: { fontFamily: 'DM Mono, monospace', fontSize: 10, color: T.accent, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 6 },
  pageTitle: { fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 28, letterSpacing: '-0.03em', color: T.text },
  bonusRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 },
  bonusCard: { background: T.surface, border: `1px solid ${T.border}`, borderRadius: 4, padding: '22px 24px' },
  bonusWho: { fontFamily: 'DM Mono, monospace', fontSize: 10, color: T.textMuted, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 8 },
  bonusVal: { fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 24, color: T.accent, letterSpacing: '-0.03em' },
  linkCard: { background: T.surface, border: `1px solid ${T.border}`, borderRadius: 4, padding: '22px 24px', marginBottom: 24 },
  monoTag: { fontFamily: 'DM Mono, monospace', fontSize: 10, color: T.textMuted, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 12 },
  linkCode: { display: 'block', fontFamily: 'DM Mono, monospace', fontSize: 13, color: T.text, padding: '10px 12px', background: T.bg, border: `1px solid ${T.border}`, borderRadius: 3, wordBreak: 'break-all' },
  ctaBtn: { border: 'none', borderRadius: 4, padding: '12px 24px', color: '#000', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif' },
  statsRow: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 0, border: `1px solid ${T.border}`, borderRadius: 4, overflow: 'hidden' },
  statItem: { padding: '20px 24px', borderRight: `1px solid ${T.border}`, background: T.surface },
  statVal: { fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 26, letterSpacing: '-0.03em', color: T.text, marginBottom: 4 },
  statLabel: { fontFamily: 'DM Mono, monospace', fontSize: 9, color: T.textMuted, textTransform: 'uppercase', letterSpacing: '0.08em' },
};
